import React, { Component } from 'react'
import "./Projects.scss"

export default class Projects extends Component {
    render() {
        return (
            <div id="projects">
                <h2><strong>Mes Projets</strong></h2>
                <div>
                    <h4>E.learncode</h4>
                    <img className="img1" src="https://image.noelshack.com/fichiers/2019/39/2/1569305643-capture-d-ecran-2019-09-24-a-08-12-00.png" width="50%" alt=""/>
                    <img className="img1" src="https://image.noelshack.com/fichiers/2019/39/2/1569305693-capture-d-ecran-2019-09-24-a-08-12-53.png" width="50%" alt=""/>
                </div>
                <p>Site statique sur le e.learning
- HTML5, CSS3, Bootstrap4, Git, Github - Développement front-end</p>

                <div>
                    <h4>World Soccer Place</h4>
                    <img className="img1" src="https://image.noelshack.com/fichiers/2019/39/1/1569259031-capture-d-ecran-2019-09-22-a-21-36-51.png" width="50%" alt=""/>
                    <img className="img1" src="https://image.noelshack.com/fichiers/2019/39/1/1569259218-capture-d-ecran-2019-09-22-a-21-37-15.png" width="50%" alt=""/>               
                    <p>Site dynamique de paris en ligne sur le foot.
- HTML5, CSS3, Bootstrap4, Git, Github, JavaScript, React, ReactStrap,APIfootball -Développement front-end</p>
</div>
            
            <div>
                    <h4>Hackathon:Eastermemory</h4>
                    <img className="img1" src="https://image.noelshack.com/fichiers/2019/39/2/1569306448-capture-d-ecran-2019-09-24-a-08-22-01.png" width="50%" alt=""/>
                    <img className="img1" src="https://image.noelshack.com/fichiers/2019/39/2/1569306494-capture-d-ecran-2019-09-24-a-08-26-43.png" width="50%" alt=""/>
                </div>
                <p>Site dynamique sur le thème de Paques, réalisé en 28h.
- HTML5, CSS3, SCSS, Git, Github, JavaScript, React, ReactStrap
- Développement front-end</p>
<div>
                    <h4>InfoMovies</h4>
                    <img className="img1" src="https://image.noelshack.com/fichiers/2019/39/2/1569331195-capture-d-ecran-2019-09-24-a-12-14-20.png" width="50%" alt=""/>
                    <img className="img1" src="https://image.noelshack.com/fichiers/2019/39/2/1569331227-capture-d-ecran-2019-09-24-a-12-15-15.png" width="50%" alt=""/>
                </div>
                <p>Site de résumé de films récents.
                - ReactJs, Redux, Git, JavaScript, Bootstrap, Reactstrap, HTML5, CSS3, SCSS, API:themoviesdb
- Développement front-end</p>

            <div>
                    <h4>C.G.B Créative :Wavager</h4>
                    <img className="imgWavager" src="https://image.noelshack.com/fichiers/2019/39/2/1569330657-capture-d-ecran-2019-09-24-a-15-03-17.png" width="20%" alt=""/>
                    <img className="imgWavager" src="https://image.noelshack.com/fichiers/2019/39/2/1569330718-capture-d-ecran-2019-09-24-a-15-04-16.png" width="20%" alt=""/>
                    <img className="img1" src="https://image.noelshack.com/fichiers/2019/39/2/1569329704-capture-d-ecran-2019-09-24-a-09-30-48.png" width="50%" alt=""/>

                </div>
                <p>Application mobile sur le thème du voyage et de l'accessibilité.
- React Native, Redux, Express, MySQL, Git, JavaScript, React, MysqlWorkbench, TablePlus, Reactstrap, PrimeReact
- Développement fullstack</p>
<div>
                    <h4>MoviesTrailers</h4>
                    <img className="img1" src="https://image.noelshack.com/fichiers/2019/39/2/1569330900-capture-d-ecran-2019-09-24-a-12-03-00.png" width="50%" alt=""/>
                    <img className="img1" src="https://image.noelshack.com/fichiers/2019/39/2/1569330938-capture-d-ecran-2019-09-24-a-12-03-46.png" width="50%" alt=""/>
                </div>
                <p>Site de bandes annonces de films récents.
- ReactJs, Redux, Git, JavaScript, Bootstrap, Reactstrap, HTML5, CSS3, SCSS, API:themoviesdb
- Développement front-end</p>
<div>
                    <h4>ValueCurrency$</h4>
                    <img className="img1" src="https://image.noelshack.com/fichiers/2019/39/2/1569331126-capture-d-ecran-2019-09-24-a-12-09-00.png" width="50%" alt=""/>
                    <img className="img1" src="https://image.noelshack.com/fichiers/2019/39/2/1569331155-capture-d-ecran-2019-09-24-a-12-09-41.png" width="50%" alt=""/>
                </div>
                <p>Site de comparateur d'une monnaie par rapport au dollard.
                - ReactJs, Redux, Git, JavaScript, Bootstrap, Reactstrap, HTML5, CSS3, SCSS, API: RESTCOUNTRIES et EXCHANGERATESAPI
- Développement front-end</p>

            </div>
        )
    }
}
